export default "__VITE_ASSET__34da125a__"